<template>
  <div class="new-visit-container">
    <transition
      name="fade"
      mode="out-in"
    >
      <div
        class="center-spinner"
        v-if="loading"
      >
        <spinner
          size="75"
          :line-size="5"
          :line-fg-color="buttonColor"
          message="Ładowanie..."
          text-fg-color="white"
        />
      </div>
    </transition>
    <transition
      name="slide"
      mode="out-in"
    >
      <div v-if="!loading">
        <div class="new-visit-wrapper">
          <template v-if="services.predefined !== undefined && services.predefined.length">
            <car-service-block
              class="card-block"
              :service="services.predefined"
              type="predefined"
              @chosen="onPredefinedChange($event)"
            />
          </template>
          <template v-if="services.custom !== undefined && services.custom.length">
            <car-service-block
              class="card-block"
              v-for="(service, index) in services.custom"
              :service="service"
              :key="'custom' + index"
              type="custom"
            />
          </template>
          <template v-if="services.additional !== undefined && services.additional.length">
            <car-service-block
              class="card-block"
              v-for="(service, index) in services.additional"
              :service="service"
              :key="'additional' + index"
              type="additional"
            />
          </template>
        </div>
        <div>
          <div v-if="isMobile">
            <!-- eslint-disable -->
            <p class="price-disclaimer">
              Podane ceny są cenami rekomendowanymi brutto w PLN. Wszelkie informacje zawarte na Audi Online Service Booking należy traktować wyłącznie orientacyjnie, gdyż nie stanowią oferty w rozumieniu Kodeksu cywilnego i nie są wiążące. Ostateczną ofertę przedstawia wybrany przez Ciebie Preferowany Partner Serwisowy i to w umowie z nim zawartej następuje wiążące ustalenie ceny.
            </p>
            <!-- eslint-enable -->
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import CarServiceBlock from '~/CarServiceBlock';
import Spinner from 'vue-simple-spinner';
import { mapGetters, mapActions } from 'vuex';

export default {
  components: {
    CarServiceBlock,
    Spinner,
  },
  data() {
    return {
      loading: true,
      chosenMileage: null,
    };
  },
  computed: {
    ...mapGetters({
      services: 'carServices/services',
      buttonColor: 'brand/getThirdColor',
      primaryColor: 'brand/getPrimaryColor',
      chosenServices: 'carServices/chosenServices',
      chosenCar: 'car/getChosenCarSpecs',
      myCars: 'myCars/getMyCars',
      registeredVisit: 'visit/registered',
      allCars: 'brand/getSpecificModels',
      selectedCarModelID: 'visit/selectedCarID',
      selectedServices: 'visit/selectedServices',
      mileage: 'visit/mileage',
    }),
    carID() {
      if (this.$route.params.id) {
        return this.$route.params.id;
      }
      return this.chosenCar.id;
    },
    isMobile() {
      return this.$mq === 'mobile' || this.$mq === 'xs';
    },
  },
  methods: {
    ...mapActions({
      fetchCarServices: 'carServices/fetchCarServices',
      setSelectedServices: 'visit/setSelectedServices',
      setSelectedCarModelID: 'visit/setSelectedCarModelID',
      resetChosenServices: 'carServices/resetChosenServices',
      setChosenService: 'carServices/setChosenService',
      setSelectedLicensePlate: 'visit/setSelectedLicensePlate',
      setRegisteredVisit: 'visit/setRegistered',
      setSelectedVin: 'visit/setSelectedVin',
      setModalContent: 'modal/setContent',
      setSelectedVisitDate: 'visit/setSelectedVisitDate',
      setSelectedPartner: 'visit/setSelectedPartner',
      setServicesPrice: 'visit/setPrice',
      setModalStep: 'modal/setModalStep',
      toggleModal: 'modal/openModal',
      setCallback: 'modal/setCallback',
      setMileage: 'visit/setMileage',
      closeModal: 'modal/closeModal',
      loadSavedData: 'visit/loadSavedData',
    }),
    onPredefinedChange(event) {
      this.chosenMileage = event.mileage;
    },
    mileageModal() {
      this.setModalContent({
        title: 'Przebieg samochodu',
      });

      this.setModalStep('car_mileage');
      this.toggleModal();
    },
  },
  mounted() {
    const isEditRoute = this.$route.path.includes('edit');

    this.loadSavedData();
    this.loading = true;
    if (!isEditRoute) {
      // change loading state after whole info fetched
      Promise.all([
        this.resetChosenServices(),
        this.fetchCarServices(this.selectedCarModelID),
      ])
        .then(() => {
          setTimeout(() => {
            if (this.selectedServices) {
              this.selectedServices.forEach((service) => {
                this.setChosenService(service);
              });
            }

            this.loading = false;
          }, 250);
        })
        .catch(() => {
          this.loading = false;
        });

      setTimeout(() => {
        this.mileageModal();
      }, 500);
    } else {
      Promise.all([
        this.resetChosenServices(),
        this.fetchCarServices(this.selectedCarModelID),
      ])
        .then(() => {
          setTimeout(() => {
            if (this.selectedServices) {
              this.selectedServices.forEach((service) => {
                this.setChosenService(service);
              });
            }
            this.loading = false;
          }, 250);
        })
        .catch(() => {
          this.loading = false;
        });
    }
  },
  beforeRouteLeave(to, from, next) {
    this.closeModal();
    next();
  },
};
</script>
